import Button from 'react-bootstrap/Button';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { excelExportActions } from "../_store";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useDispatch, useSelector } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
export function ExportModal(props) {
    const [excel, setExcel] = useState(false);
    const dispatch = useDispatch();
    let getFilterObj;
    let { excelExport } = useSelector(x => x.excelExport);
    
    useEffect(() => {
        if (localStorage.getItem('filterObjValues')) {
            getFilterObj = JSON.parse(localStorage.getItem('filterObjValues'))
            // dispatch(excelExportActions.getAll(getFilterObj));
        }

    }, [])


    const cancelModal = () => {
        props.onHide();
        setExcel(false)
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        if (excel) {
            if (localStorage.getItem('filterObjValues')) {
                getFilterObj = JSON.parse(localStorage.getItem('filterObjValues'))
                getFilterObj.pageNumber = '';
                getFilterObj.pageSize='';
                dispatch(excelExportActions.getAll(getFilterObj));
            }
           

        }

    }
    useEffect(() => {
        if (excelExport.result) {
            const link = document.createElement('a');
            link.href = excelExport.result.fileRelativePath + '/' + excelExport.result.fileName;
            link.download = 'TekCCReceipts.xlsx'
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // const pathUrl = excelExport.result.fileRelativePath + '/' + excelExport.result.fileName;
            // const w = window.open(pathUrl, '_blank');
            // w.document.title = 'Tekzenit Receipts';
            props.onHide();
            setExcel(false);
        }
    },[excelExport])
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="export-modal filter-modal"
            >
            <h4>Export Files</h4>
            <Modal.Body>
                <div className="form-overlay">
                    <div className="receipts edit-receipts">
                        {excelExport.loading &&
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>}

                        <Form onSubmit={handleSubmit}>
                            <div className='export-dashboard'>
                                {!excelExport.loading &&
                                    <div key='export-excel' className="checkbox-export">
                                        <Form.Check
                                            type="checkbox"
                                            id='export-excel'
                                            label="Export To Excel"
                                            required
                                            onChange={(event) => setExcel(event.target.checked)}
                                        />

                                        <Form.Check
                                            disabled
                                            type="checkbox"
                                            id='export-pdf'
                                            label="Export To PDF"
                                        />
                                        {excelExport.error &&
                                            <div className='error-msg'>{excelExport.error.message}</div>}
                                    </div>
                                }

                            </div>
                            <div className='flex'>
                                <OverlayTrigger
                                    key='bottom-filter'
                                    placement='bottom'
                                    overlay={
                                        <Tooltip id='tooltip-filter'>
                                            Export
                                        </Tooltip>
                                    }
                                >
                                    <Button type="submit"> <img src={'/assets/icons/checkmark.svg'} /></Button>

                                </OverlayTrigger>
                                <OverlayTrigger
                                    key='bottom-cancel'
                                    placement='bottom'
                                    overlay={
                                        <Tooltip id='tooltip-cancel'>
                                            Cancel
                                        </Tooltip>
                                    }
                                >
                                    <Button onClick={cancelModal} className="close-button"> <img src={'/assets/icons/close.svg'} /></Button>
                                </OverlayTrigger>
                            </div>
                        </Form>
                    </div>
                </div>
            </Modal.Body>

        </Modal>
    );

}